import type { ConditionBuild } from "../schemas/index.ts";

export const traverseConditions = (rootCondition: ConditionBuild, onCondition: (condition: ConditionBuild) => void) => {
  const traverse = (condition: ConditionBuild) => {
    onCondition(condition);

    for (const childOrChilds of Object.values(condition.children ?? {})) {
      if (Array.isArray(childOrChilds)) {
        for (const child of childOrChilds) {
          traverse(child);
        }
      } else if (childOrChilds) {
        traverse(childOrChilds);
      }
    }
  };

  traverse(rootCondition);
};
